export default {
      id: "starEmpty-usage",
      viewBox: "0 0 32 30",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#starEmpty-usage",
      toString: function () {
        return this.url;
      }
    }